<div>
  <label [for]="textField.for" class="bmd-label-floating">{{textField.label}}</label>
  <input [type]="textField.type" placeholder="email" class="form-control" [id]="textField.id" #email="ngModel" [(ngModel)]="textField.model" [name]="textField.model"
    required="" />
      <!-- <mat-form-field class="example-full-width">
        <mat-label>{{textField.label}}</mat-label>
        <input [type]="textField.type" matInput [placeholder]="textField.placeholder" [value]="textField.model" [name]="textField.name">
      </mat-form-field> -->
  <div class="d-flex">
      <i class="material-icons error-icon">warning</i>
      <span class="text-field-error-msg">This field is required</span>
  </div>
</div>